import { ChimneyIcon } from '@/common/components/icons'
import ReportSectionCard from '../ReportSectionCard'
import { WasteGasExportedEmission, WasteGasImportedEmission } from '@/api/EmissionReportModel'
import { DataBlock, GenericDialog } from '@/common'
import { UnitLabel } from '@/shared/config/config'
import useDialog from '@/common/hooks/useDialog'
import WasteGasReporting from './WasteGasReporting'
import useI18n from '@/shared/hooks/useI18n'

export default function WasteGasSection({
  isComplete,
  wasteGasImportedEmission,
  wasteGasExportedEmission,
  isViewMode,
  reportId,
  emissions,
  processId
}: {
  isComplete: boolean
  wasteGasImportedEmission: WasteGasImportedEmission | null
  wasteGasExportedEmission: WasteGasExportedEmission | null
  isViewMode: boolean
  reportId: string
  emissions: number
  processId: string
}) {
  const { t, numberFormatter3Decimals } = useI18n()
  const { open, openDialog, closeDialog } = useDialog()

  const wasteGasImportedEmissionValue = numberFormatter3Decimals(
    wasteGasImportedEmission?.emission || 0
  )
  const wasteGasExportedEmissionValue = numberFormatter3Decimals(
    wasteGasExportedEmission?.emission || 0
  )

  const completionPercentage = isComplete ? 100 : 0

  return (
    <>
      <ReportSectionCard
        title={t('report:wasteGas.title')}
        reportButtonText={t('report:wasteGas.reportButtonText')}
        icon={<ChimneyIcon className="size-4" />}
        onEdit={openDialog}
        isComplete={isComplete}
        isViewMode={isViewMode}
        emissions={emissions}
        completionPercentage={completionPercentage}
      >
        <div className="grid grid-cols-2 gap-2">
          <DataBlock
            label={t('report:wasteGas.imported')}
            data={`${wasteGasImportedEmissionValue} ${UnitLabel.tCO2e}`}
          />
          <DataBlock
            label={t('report:wasteGas.exported')}
            data={`${wasteGasExportedEmissionValue} ${UnitLabel.tCO2e}`}
          />
        </div>
      </ReportSectionCard>
      <GenericDialog
        title={t('report:wasteGas.title')}
        isOpen={open}
        close={closeDialog}
        size="4xl"
      >
        <WasteGasReporting
          wasteGasImportedEmissions={wasteGasImportedEmission || null}
          wasteGasExportedEmissions={wasteGasExportedEmission || null}
          close={closeDialog}
          reportId={reportId}
          processId={processId}
        />
      </GenericDialog>
    </>
  )
}
